
export default {
  baseUrl: process.env.REACT_APP_ENDPOINT
}
